import { render, staticRenderFns } from "./BrandsDropdown.vue?vue&type=template&id=e33449f8&scoped=true&"
import script from "./BrandsDropdown.vue?vue&type=script&lang=js&"
export * from "./BrandsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BrandsDropdown.vue?vue&type=style&index=0&id=e33449f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33449f8",
  null
  
)

export default component.exports